export const processStatuses = {
	pending: 'PENDING',
	success: 'SUCCESS',
	failed: 'FAILED',
	error: 'ERROR',
}

export const processErrors = {
	pollFailed: 'Unable to check process status.',
	processFailed: 'Unable to process the data.',
	templateFailed: 'Unable to process the data. Please check your template.',
}
